export const environment = {
  production: true,
  buildId: '2958806255419811',
  configFile: 'config.json',
};
